import {TimelineTimeAxisScaleType} from 'vis-timeline/esnext';
import { ScaleType } from '../../scale.type';

const MECHANICS_SCALE_SETTINGS: Map<TimelineTimeAxisScaleType, ScaleType> = new Map();
MECHANICS_SCALE_SETTINGS.set('day', {
    columnWidth: 250,
    columnCount: 30,
    name: 'Tagesansicht',
    iconName: 'calendar-today',
    buttonColor: 'green'
});

export {MECHANICS_SCALE_SETTINGS};
